import { cn } from "@qw/ui";
import type { FC, HTMLAttributes } from "react";

export interface ChatMessageProps extends HTMLAttributes<HTMLElement> {}

export const ChatMessage: FC<ChatMessageProps> = ({ children, className, ...props }) => {
  return (
    <article className={cn("group/chat-message -mx-4 min-w-0 overflow-x-hidden", className)} {...props}>
      <div className="flex min-w-0 flex-col gap-1 py-1 px-4">{children}</div>
    </article>
  );
};

export interface ChatMessageContentProps extends HTMLAttributes<HTMLElement> {}

export const ChatMessageContent: FC<ChatMessageContentProps> = ({ children, className, ...props }) => {
  return (
    <div className={cn("leading-relaxed text-sm w-full min-w-0 wrap-break-word hyphens-auto", className)} {...props}>
      {children}
    </div>
  );
};

export interface ChatMessageFooterProps extends HTMLAttributes<HTMLElement> {}

export const ChatMessageFooter: FC<ChatMessageFooterProps> = ({ children, className, ...props }) => {
  return (
    <div className={cn("text-2xs text-muted-foreground flex items-center", className)} {...props}>
      {children}
    </div>
  );
};
